import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import type { RootState } from "../../store/store";
import { hasModuleFromToken } from "../../utils/authToken";
import { moduleForPath } from "../../utils/accessModules";
import { isTokenValid } from "../../utils/isTokenValid";
import { HOMEPAGE } from "../../views/home/routes";
import Topbar from "./Topbar";

/**
 * Layout das telas do staff: a Topbar uma vez só, por cima da tela da rota.
 * Rota de layout sem `path` no `App` — cada rota filha continua com o próprio
 * guard (`AdminRoute`, `DpRoute`...).
 *
 * Também é o ponto único que barra a tela de módulo retirado do administrador
 * restrito (ADR 0027): a URL aberta direto volta para o Início.
 */
export default function StaffLayout() {
  const { pathname } = useLocation();
  const token = useSelector((s: RootState) => (s as any).auth?.accessToken);

  const module = moduleForPath(pathname);
  const moduleRevoked = isTokenValid(token) && !!module && !hasModuleFromToken(token, module);

  useEffect(() => {
    if (moduleRevoked) toast.error("Este módulo não faz parte do seu acesso.", { toastId: "module-revoked" });
  }, [moduleRevoked]);

  if (moduleRevoked) return <Navigate to={HOMEPAGE()} replace />;

  // Sem sessão de staff válida o guard da rota vai redirecionar: não pisca a barra.
  // O supervisor também tem barra (redesign de 15/10/2026): a dele mostra só o que ele abre.
  const hideTopbar = !isTokenValid(token);

  return (
    <>
      {hideTopbar ? null : <Topbar />}
      <Outlet />
    </>
  );
}
